import React from 'react';
import { useTranslation } from 'react-i18next';
import './SeoHero.css';

function SeoHero() {
  const { t } = useTranslation();
  return (
    <section className="seo-hero">
      <h2 className="seo-hero-title">{t('homepage.seoHero.title', 'Crea tu itinerario de viaje con IA en 60 segundos')}</h2>
      <p className="seo-hero-lead">{t('homepage.seoHero.description', 'Planiaro genera itinerarios personalizados día a día: actividades, horarios, transporte y presupuesto estimado. Solo indica tu destino, fechas y preferencias.')}</p>
      <p className="seo-hero-lead seo-hero-small">{t('homepage.seoHero.footer', 'Planificador de viajes con IA gratis. Sin registro, sin límites. Empieza ahora.')}</p>
    </section>
  );

}

export default SeoHero;
